import React from 'react';
import sprintf from 'sprintf';
import SMPaymentSelectHelper from 'components/helpers/SMPaymentSelectHelper';
import SMCardHelper from 'components/helpers/SMCardHelper';
import SMConst from 'lib/SMConst';
import SMBillingList from 'components/dashboard/shared/SMBillingList';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMGraphQLClient from 'lib/SMGraphQLClient';
import 'babel-polyfill';
import { companyFragment } from 'fragments';

class SMReservationPayRequestView extends React.Component {

  constructor(props) {
    super(props);

    this.requestParams = {
      payment_method: props.reservation.billing.payment_method,
      payment_id: null,
      is_hourly: props.reservation.is_hourly,
      plan_id: props.reservation.plan_id,
    };

    this.state = {
      reservation: props.reservation,
      capacities: [],
      cardErrorMessage: "",
      pointErrorMessage: "",
      witchCardError: null,
      couponErrorMessage: "",
      isDisabled: false,
      isAppliedCoupon: false,
      isAppliedPoint: false,
      selectedDiscount: 0,
      activeCards: [],
      couponCode: "",
      applyPointAmount: "",
      paymentSelect: null,
      errors: {},
      isCardOnly: (!this.props.reservation.room.space.enable_bank_payment || this.props.reservation.use_type != SMConst.ReservationUseType.Corporate),
      openNewCard: false,
      selectedCard: null,
      companies: [],
      selectedCompany: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ reservation: nextProps.reservation });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
      $(this.refs.form).startLoading();
      this.requestPayments();
      this.requestCompanies();

      SMTrackHelper.pageView(location.pathname + "/request");
    }
  }

  async requestCompanies() {
    const apiClient = new SMGraphQLClient();
    const query = `
      query {
        viewer {
          companies {
            results{
              ... on Company {
                ${companyFragment}
              }
            }
          }
        }
      }
    `;
    const obj = await apiClient.request(query);

    if (!obj) return false;
    if (obj.errors) {
      console.log(obj.errors);
      return false;
    }

    this.setState({
      companies: obj.data.viewer.companies.results
    });
  }

  dismiss(e) {
    this.setState({ isAppliedCoupon: false });
    this.requestParams.coupon_code = '';
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.requestViewDidClose === 'function'){
        this.props.delegate.requestViewDidClose();
      }
    }
  }

  requestPayments() {
    SMUserResource.getPayments(this.props.currentUser.id, (activeCards, error, xhr)=>{
      if (!error) {
        this.setState({
          activeCards: activeCards,
          openNewCard: false
        });
        if (activeCards && activeCards.length > 0) {
          this.setPayment(SMConst.PaymentSelect.Card, activeCards[0].id);
        } else if (this.props.reservation.billing.payment_method == SMConst.PaymentMethod.Bank){
          this.setPayment(SMConst.PaymentSelect.Bank, null);
        }
        $(this.refs.form).stopLoading();
      } else {
        $(this.refs.form).stopLoading();
        switch (xhr.status) {
          case 400:
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 402:
            break;
        }
      }
    });
  }

  requestReservation() {
    this.setState({display: SMConst.Display.Loading});

    const responseHandler = (reservation, error, xhr)=>{
      if (error) {
        this.setState({
          isDisabled: false,
          display: SMConst.Display.Visible,
        });

        $(this.refs.form).stopLoading();
        switch (xhr.status) {
          case 400:
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 402:
            this.setState({
              cardErrorMessage: JSON.parse(xhr.responseText).message,
              witchCardError: this.state.paymentSelect,
              isDisabled: false,
            });
            break;
        }
      } else {
        const room = reservation.room;
        SMAppHelper.redirectTo(Routes.sent_space_room_reservation_path(room.space.username, room.uid, reservation.uid));
      }
    };
    SMUserResource.payReservation(this.props.currentUser.id, this.props.reservation.id, this.requestParams, responseHandler);
  }

  formDidSubmit(e) {
    e.preventDefault();
    this.setState({
      cardErrorMessage: "",
      witchCardError: null,
      isDisabled: true,
    });
    this.requestReservation();
  }

  discountDidChangeValue(e) {
    this.setState({
      selectedDiscount: parseInt(e.currentTarget.value),
    });
  }

  couponApplyButtonDidClick(e) {
    this.setState({ couponCode: this.refs.inputCouponCode.value });
    this.requestParams.coupon_code = this.refs.inputCouponCode.value;
    SMUserResource.recalcGuestAmount(this.props.currentUser.id, this.props.reservation.id, this.requestParams, {}, (reservation, error, xhr)=>{
      if (error) {
        this.requestParams.coupon_code = '';
        this.setState({ couponErrorMessage: xhr.responseJSON.message });
      } else {
        this.setState({ couponErrorMessage: '', isAppliedCoupon: true, reservation: reservation });
      }
    });
  }

  couponRevokeButtonDidClick(e) {
    // クーポン情報戻す
    this.requestParams.coupon_code = '';
    this.setState({ isAppliedCoupon: false });
    this.billingRecalc();
  }

  couponCodeDidChange(e) {
    this.setState({ couponCode: e.currentTarget.value });
  }

  pointApplyButtonDidClick(e) {
    this.setState({ applyPointAmount: this.refs.inputApplyPointAmount.value });
    this.requestParams.apply_point_amount = this.refs.inputApplyPointAmount.value;
    SMUserResource.recalcGuestAmount(this.props.currentUser.id, this.props.reservation.id, this.requestParams, {}, (reservation, error, xhr)=>{
      if (xhr.status != 200) {
        this.requestParams.apply_point_amount = '';
        this.setState({ pointErrorMessage: xhr.responseJSON.message });
      } else {
        this.setState({ pointErrorMessage: '', isAppliedPoint: true, reservation: reservation });
      }
    });
  }

  applyPointDidChange(e) {
    this.setState({ applyPointAmount: e.currentTarget.value });
  }

  pointRevokeButtonDidClick(e) {
    this.requestParams.apply_point_amount = '';
    this.setState({ isAppliedPoint: false });
    this.billingRecalc();
  }

  businessUseDescriptionDidChange(e) {
    const val = e.currentTarget.value;
    this.requestParams.business_use_description = val;
    this.setState({
      businessUseDescription: val
    });
  }

  renderCardError() {
    if (this.state.cardErrorMessage && this.state.witchCardError == this.state.paymentSelect) {
      let className = ["reserve-change__required"];
      SMPaymentSelectHelper.isCard(this.state.paymentSelect) ? className.push("ml20") : className.push("mt10");
      return(
        <p className={className.join(' ')}><i className="fa fa-exclamation-circle"></i>{this.state.cardErrorMessage}</p>
      );
    }
    return null;
  }

  renderDiscountForm() {
    if (this.props.reservation.billing.payment_method) return null;

    return (
      <div>
        <h3 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>ポイント/クーポンの利用
        </h3>
        <input type="radio" value={0} id="point-coupon-radio-01" name="point-coupon-radio" checked={this.state.selectedDiscount == 0} onClick={this.discountDidChangeValue.bind(this)} disabled={this.state.isAppliedCoupon} />
        <label htmlFor="point-coupon-radio-01" className="service-radio"><span className="request-payment__name">ポイント</span></label>
        <input type="radio" value={1} id="point-coupon-radio-02" name="point-coupon-radio" checked={this.state.selectedDiscount == 1} onClick={this.discountDidChangeValue.bind(this)} disabled={this.state.isAppliedPoint} />
        <label htmlFor="point-coupon-radio-02" className="service-radio"><span className="request-payment__name">クーポン</span></label>
        <p className="dashboard-title__supplement dib">ポイントとクーポンの併用はできません。</p>
        {this.state.selectedDiscount == 0 ? this.renderPointForm() : this.renderCouponForm()}
      </div>
    );
  }

  renderPointForm() {
    if (this.state.isAppliedPoint) {
      return(
        <div className="mt20">
          <div>
            <p className="pt9 pb9">
              {this.state.applyPointAmount}ポイント
              <a onClick={this.pointRevokeButtonDidClick.bind(this)} className="a__underline ml10"><i className="fa fa-times mr3" />削除</a>
            </p>
            <p className="is-available mt10"><i className="fa fa-check-circle" />ポイントが適用されました。</p>
          </div>
        </div>
      );
    } else {
      return(
        <div className="mt20">
          <div className="mb20">
            <p className="popup-form__text mb10">ポイントをご利用の方はポイント数を入力してください。</p>
            <input type="text" value={this.state.applyPointAmount} className="form-text w200" placeholder="半角数字で入力" ref='inputApplyPointAmount' onChange={this.applyPointDidChange.bind(this)} />
            <input type="button" className="button-blue w50 pt10 pb10 ml10" defaultValue="適用" onClick={this.pointApplyButtonDidClick.bind(this)} />
            <p className="dashboard-title__supplement mt10">所持ポイント：<span className="popup-form__point-now">{this.props.currentUser.point_balance.available_amount}</span></p>
            {this.renderPointError()}
          </div>
        </div>
      );
    }
  }

  renderCouponForm() {
    const applyButtonClassName = `button-blue w70 pt10 pb10 ml10 ${(this.state.couponCode) ? '' : 'button-disabled'}`;
    //すでにクーポンが適用されている場合はクーポンフォームを非表示にする
    if (this.props.reservation.billing.is_applied_coupon) return null;

    let row = null;
    if (this.state.isAppliedCoupon) {
      return (
        <div className="mt20">
          <div>
            <p className="pt9 pb9">
              {this.state.couponCode}
              <a onClick={this.couponRevokeButtonDidClick.bind(this)} className="a__underline ml10"><i className="fa fa-times mr3" />削除</a>
            </p>
            <p className="is-available mt10"><i className="fa fa-check-circle" />クーポンが適用されました。</p>
          </div>
        </div>
      );
    } else {
      return(
        <div className="mt20">
          <div className="mb20">
            <p className="popup-form__text mb10">ポイントをご利用の方はポイント数を入力してください。</p>
            <input type="text" value={this.state.couponCode} className="form-text w200" ref='inputCouponCode' placeholder="クーポンコードを入力" onChange={this.couponCodeDidChange.bind(this)} />
            <input type="button" className={applyButtonClassName} value="適用" onClick={this.couponApplyButtonDidClick.bind(this)} disabled={!this.state.couponCode} />
            {this.renderCouponError()}
          </div>
        </div>
      );
    }
  }

  renderFormItemError(name) {
    const message = this.state.errors[name];
    if (message) {
      return <p className="is-error mb40"><i className="fa fa-exclamation-circle"></i>{message}</p>;
    }
    return null;
  }

  renderCouponError() {
    if (this.state.couponErrorMessage) {
      return <p className="is-error mt10"><i className="fa fa-exclamation-circle"></i>{this.state.couponErrorMessage}</p>;
    }
    return null;
  }

  renderPointError() {
    if (this.state.pointErrorMessage) {
      return <p className="is-error mt10"><i className="fa fa-exclamation-circle"></i>{this.state.pointErrorMessage}</p>;
    }
    return null;
  }

  renderActiveCards() {
    const cards = this.state.activeCards;
    const rows = [];
    if (cards) {
      cards.forEach((card, index) => {
        let cardType = card.type.toLowerCase();
        if (cardType == "american express") {
          cardType = "amex";
        }
        const className = sprintf("fa fa-cc-%s fa-lg payment-card__%s", cardType, cardType);

        rows.push(
          <div key={card.id}>
            <input type="radio"
              onClick={this.paymentDidSelect.bind(this)}
              value={SMConst.PaymentSelect.Card}
              checked={SMPaymentSelectHelper.isCard(this.state.paymentSelect) && this.state.selectedCard == card.id}
              id={"form-radio02__" + card.id}
              name="form-radio02"
              data-paymentId={card.id} />
            <label htmlFor={"form-radio02__" + card.id} className="form-radio mb20">
              <span className="mr10 form-payment-data">
                <i className={className}></i><strong className="settings-data"> **** **** **** {card.last4}</strong></span>
              <span className="mr10 form-payment-data">名義人：<strong className="settings-data">{card.name}</strong></span>
              <span className="mr10 form-payment-data">有効期限：<strong className="settings-data">{card.exp_month}/{card.exp_year}</strong></span></label>
          </div>
        );
      });
    }

    return(rows);
  }

  didClickAddNewCard(e) {
    e.preventDefault();

    const helper = new SMCardHelper();
    $(this.refs.form).startLoading();
    helper.generateToken({
      success: (response)=>{
        helper.removeCardItemBeforeSubmit();
        SMUserResource.postPayment(this.props.currentUser.username, response.id, (data, error, xhr)=>{
          if(!error) {
            this.setState({
              cardErrorMessage: ""
            });
            this.requestPayments();
          } else {
            this.setState({
              cardErrorMessage: response.error.message,
              witchCardError: this.state.paymentSelect,
              isDisabled: false,
            });
          }
        });
      },
      error: (response)=>{
        $(this.refs.form).stopLoading();
        this.setState({
          cardErrorMessage: response.error.message,
          witchCardError: this.state.paymentSelect,
          isDisabled: false,
        });
      }
    });
  }

  toggleNewCard(e) {
    e.preventDefault();

    this.setState({
      openNewCard: !this.state.openNewCard
    });
  }

  renderNewCard() {
    if (!this.state.openNewCard) return null ;

    let card = ["","","","","","","",""];
    if (SpaceMarket.Config.Env == "development") {
      card = ["4242","4242","4242","4242","Dummy","06","2020","111"];
    }

    let yearOptions = [];
    const thisYear = (new Date()).getFullYear();
    for (let year = thisYear; year < thisYear + 20; year++) {
      yearOptions.push(
        <option key={year} value={year}>{year}</option>
      );
    }

    let monthOptions = [];
    for (let month = 1; month <= 12; month++) {
      monthOptions.push(
        <option key={month} value={sprintf("%02d", month)}>{month}</option>
      );
    }
    let newCardStyle = {};
    if (this.state.activeCards) {
      newCardStyle = {display: "none"};
    }

    let errorMessage = null;
    if (this.state.cardErrorMessage) {
      errorMessage = <p className="mb15 is-error"><i className="fa fa-exclamation-circle"></i><span>{this.state.cardErrorMessage}</span></p>;
    }

    return(
      <div className="ml30">
        <div className="ml120">
          {errorMessage}
          <h3 className="mb5">
            カード番号
            <i className="fa fa-cc-visa fa-lg ml5 payment-card__visa"></i><i className="fa fa-cc-mastercard fa-lg ml5 payment-card__master"></i><i className="fa fa-cc-amex fa-lg ml5 payment-card__amex"></i>
          </h3>
          <div className="mb15">
            <input type="text" name="card[no_1]" defaultValue={card[0]} id="js-card_no_1" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
            <input type="text" name="card[no_2]" defaultValue={card[1]} id="js-card_no_2" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
            <input type="text" name="card[no_3]" defaultValue={card[2]} id="js-card_no_3" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
            <input type="text" name="card[no_4]" defaultValue={card[3]} id="js-card_no_4" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
          </div>
          <h3 className="mb5">
            名義人
            <span className="dashboard-title__supplement ml15">
              クレジットカード表記のまま入力してください。半角英数。
            </span>
          </h3>
          <div className="mb15">
            <input type="text" name="card[name]" defaultValue={card[4]} id="js-card_name" autoComplete="off" placeholder="Taro Space" className="js-card-item__remove form-text w400" />
          </div>
          <h3 className="mb5">
            有効期限
          </h3>
          <div className="mb15">
            <span className="form-select__inner">
              <label className="form-select">
                <select name="card[exp_m]" id="js-card_exp_m" defaultValue={card[5]} className="js-card-item__remove service-select__purpose w70">
                  {monthOptions}
                </select>
              </label>
            </span>
            <span className="form-select__inner">
              <label className="form-select">
                <select name="card[exp_y]" id="js-card_exp_y" defaultValue={card[6]} className="js-card-item__remove service-select__purpose w110">
                  {yearOptions}
                </select>
              </label>
            </span>
          </div>
          <h3 className="mb5">
            セキュリティコード
            <span className="dashboard-title__supplement ml15">
              裏面右端の3桁もしくは表面右端の4桁の数字を入力してください。
            </span>
          </h3>
          <div className="mb15">
            <input className="js-card-item__remove w70" type="text" name="card[cvc]" defaultValue={card[7]} id="js-card_cvc" maxLength="4" autoComplete="off" />
            {SMPaymentSelectHelper.isCard(this.state.paymentSelect) ? this.renderCardError() : null}
          </div>
          <div className="mb20">
            <input onClick={this.didClickAddNewCard.bind(this)} type="button" className="button-blue w100 pt10 pb10" value="追加" />
          </div>
        </div>
      </div>
    );
  }

  paymentDidSelect(e) {
    const value = parseInt(e.currentTarget.value);
    let paymentId = null;
    let companyId = null;
    if (e.currentTarget.getAttribute('data-paymentId')) {
      paymentId = parseInt(e.currentTarget.getAttribute('data-paymentId'));
    }
    if (e.currentTarget.getAttribute('data-companyId')) {
      companyId = parseInt(e.currentTarget.getAttribute('data-companyId'));
    }
    this.setPayment(value, paymentId, companyId);
    this.billingRecalc();
  }

  setPayment(value, paymentId, companyId) {
    this.setState({paymentSelect: value});
    switch (value) {
      case SMConst.PaymentSelect.Card:
        this.requestParams.destination_type = SMConst.BillingDestinationType.User;
        this.requestParams.payment_method = SMConst.PaymentMethod.Card;
        this.requestParams.payment_id = paymentId;
        this.setState({selectedCard: paymentId});
        break;
      case SMConst.PaymentSelect.Postpay:
        this.requestParams.destination_type = SMConst.BillingDestinationType.User;
        this.requestParams.payment_method = SMConst.PaymentMethod.Postpay;
        break;
      case SMConst.PaymentSelect.BusinessAccount:
        this.requestParams.destination_type = SMConst.BillingDestinationType.Company;
        this.requestParams.company_id = companyId;
        this.requestParams.payment_method = "";
        this.setState({selectedCompany: companyId});
        break;
      case SMConst.PaymentSelect.Bank:
        this.requestParams.payment_method = SMConst.PaymentMethod.Bank;
        break;
    }
  }

  billingRecalc() {
    SMUserResource.recalcGuestAmount(this.props.currentUser.id, this.props.reservation.id, this.requestParams, {}, (reservation, error, xhr)=>{
      if (error) {
        this.setState({reservation: this.props.reservation});
      } else {
        this.setState({reservation: reservation});
      }
    });
  }

  renderBusinessDescription() {
    if (!SMPaymentSelectHelper.isBusinessAccount(this.state.paymentSelect)) return false;
    const companyId = this.state.selectedCompany;
    const company = this.state.companies.find((company) => {
      return company.id == companyId;
    });

    return(
      <div>
        <h3 className="dashboard-title mb20 dib">
          <span className="icon-form icon-form__required">必須</span>{company.name}への説明
        </h3>
        <p className="dashboard-title__supplement mb10">{company.name}にこの予約について説明しましょう。どんなイベント・会議で利用するのかなどを伝えることで、支払い業務がスムーズになります。</p>
        <textarea
          value={this.state.businessUseDescription}
          onChange={this.businessUseDescriptionDidChange.bind(this)}
          name="business_use_description"
          className="form-textarea w100per mb40 h100"
          placeholder="12/20の会社設立10周年記念イベントの会場に使いたいと考えています。プロジェクターや全社員300人分の椅子もそろっています。よろしくお願いします。" />
        {this.renderFormItemError('business_use_description')}
      </div>
    );
  }

  render() {
    if (!this.props.isOpen) return null;
    const room = this.props.room;
    const paymentMethod = this.props.reservation.billing.payment_method;
    const buttonClassName = `button-blue request-submit ${(this.state.isDisabled) ? "button-disabled" : ''}`;
    const canPayCard = room.owner.enable_card;
    const cardSelectStyle = canPayCard ? {} : {display: "none"};
    const bankSelectStyle = (!SMAppHelper.isSpacemarketEmployee(this.props.currentUser) && paymentMethod !== SMConst.PaymentMethod.Bank) || this.state.isCardOnly ? {display: "none"} : {};
    const postpaySelectStyle = (this.state.isCardOnly && canPayCard) || paymentMethod === SMConst.PaymentMethod.Bank ? {display: "none"} : {};
    const newCardStyle = this.state.openNewCard ? "fa fa-chevron-down mr5" : "fa fa-chevron-right mr5";
    const businessAccountSelectStyle = this.state.isCardOnly && this.state.companies.length > 0 ? {display: "none"} : {};

    return(
      <div>
        <div className="md-modal md-effect-101" ref="modal">
          <div className="form-casette maincol-lightbox__form reserve-change">
            <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
              <h3 className="dashboard-title mb20">
                <span className="icon-form icon-form__required">必須</span>お支払い方法の選択
              </h3>
              <div style={cardSelectStyle}>
                <div className="mb20">
                  <div className="mb20">
                    <p className="dashboard-title2">クレジットカード</p>
                  </div>
                </div>
                <div className="ml30">
                  {this.renderActiveCards()}
                  <div className="mb20"><a onClick={this.toggleNewCard.bind(this)} href="" className="link-hover-border"><i className={newCardStyle}></i>新しいカードを追加</a></div>
                  {this.renderNewCard()}
                </div>
              </div>
              <div style={postpaySelectStyle}>
                <div className="form-box">
                  <input type="radio"
                    onClick={this.paymentDidSelect.bind(this)}
                    value={SMConst.PaymentSelect.Postpay}
                    checked={SMPaymentSelectHelper.isPostpay(this.state.paymentSelect)}
                    id="form-radio01__03"
                    name="form-radio01" />
                  <label htmlFor="form-radio01__03" className="form-radio dashboard-title2">銀行振込(後払い)</label>
                </div>
              </div>
              <div style={bankSelectStyle}>
                <div className="form-box">
                  <input type="radio"
                         onClick={this.paymentDidSelect.bind(this)}
                         value={SMConst.PaymentSelect.Bank}
                         checked={SMPaymentSelectHelper.isBank(this.state.paymentSelect)}
                         id="form-radio01__02"
                         name="form-radio02" />
                  <label htmlFor="form-radio01__02" className="form-radio dashboard-title2">銀行振込</label>
                </div>
              </div>
              {this.state.companies.map((company) => {
                return(
                  <div style={businessAccountSelectStyle}>
                    <div className="mb40">
                      <input type="radio"
                        id={`form-radio01__03_${company.id}`}
                        onClick={this.paymentDidSelect.bind(this)}
                        name="company_id"
                        value={SMConst.PaymentSelect.BusinessAccount}
                        data-companyId={company.id}
                        checked={SMPaymentSelectHelper.isBusinessAccount(this.state.paymentSelect) && this.state.selectedCompany == company.id} />
                      <label htmlFor={`form-radio01__03_${company.id}`} className="form-radio dashboard-title2">{company.name}に請求</label>
                    </div>
                  </div>
                );
              })}
              {this.renderBusinessDescription()}
              {this.renderFormItemError('payment_method')}
              {this.renderDiscountForm()}
              <h2 className="dashboard-title mb20 mt50">申込内容の詳細</h2>
              <SMBillingList key={this.state.reservation.id} reservation={this.state.reservation} isOwner={false} />
              <div className="mt30 mb30 ta-c">
                <input className="button-green maincol-buttonarea__button {buttonClassName}" type="submit" value="上記の内容で支払う" disabled={this.state.isDisabled} />
              </div>
            </form>
          </div>
        </div>
        <div className="md-overlay"></div>
      </div>
    );
  }
}
export default SMReservationPayRequestView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationPayRequestView.jsx